import React, { useContext, useEffect } from 'react'
import { COMPUTED_SUBSTITUTIONS } from 'Pages/GMS/ARS/ARSConstants';
import Tab from 'Components/DesignSystem/Tab/Tab';
import Typography from 'Components/DesignSystem/Typography/Typography';
import Button from 'Components/DesignSystem/Button/Button';
import ComputedSubstitutionComponent from './ComputedSubstitutionView';
import { computedSubstitutionTabs } from '../constants/CSConstants';
import { IterationContext, IterationContextProvider, IterationContextType } from '../contexts/IterationContext';
import { toast } from 'Components/DesignSystem/Toast/useToast';
import { AppContext } from 'Context/AppContext';
import { useNavigate } from "react-router";
import IterationTable from '../components/iteration/IterationTable';

const CSView = () => {
    return (
        <IterationContextProvider>
            <CSTabView isSidePanel={false} />
        </IterationContextProvider>
    );
}

export default CSView

type CSTabViewProps = { isSidePanel: boolean }

const CSTabView = ({ isSidePanel }: CSTabViewProps) => {
    const { activeTab, onTabChange } = useContext<IterationContextType>(IterationContext);
    const appData = useContext(AppContext);
    const navigate = useNavigate();
    const { readPermission } = useContext<IterationContextType>(IterationContext);
    const createPermission = appData?.pm?.checkPermission("gmssubstitution_create")

    useEffect(() => {
        if (isSidePanel) return;
        if (!readPermission) {
            navigate("/workspace/module/permission/denied");
            return;
        }
    }, [isSidePanel]);

    const tabLabels: Record<ComputedSubstitutionTabType, string> = {
        'iteration': 'Iteration Method',
        'weightage': 'Weightage Method'
    };

    const handleCreate = () => {
        if (!readPermission) {
            toast.error("You don't have permission to create iteration method")
            return;
        }

        if (activeTab === "weightage") { createWeigtage() }
        else { createIteration() }
    }

    const createWeigtage = () => {
        if (!createPermission) {
            toast.info("You dont have permission for this operation")
            return
        }
        navigate("/gms/substitutions/create/null/null")
    }

    const createIteration = () => {
        if (!createPermission) {
            toast.info("You dont have permission for this operation")
            return
        }
        navigate("/gms/substitutions_iteration/create")
    }

    const tabItems = computedSubstitutionTabs.map((tab) => ({
        id: tab,
        label: tabLabels[tab],
        'data-testid': `tab-${tab}`,
    }));

    return (
        <>
            <div className='tw-w-full'>
                <Typography variant="display" as="h1" id="cs-title" data-testid="substitutions-title" className="tw-text-ink tw-text-left tw-my-3.5">
                    {COMPUTED_SUBSTITUTIONS}
                </Typography>
            </div>
            <div className="tw-w-full tw-border-b tw-border-edge"></div>

            <div className="tw-flex tw-justify-between tw-items-end">
                <Tab
                    tabs={tabItems}
                    activeTabId={activeTab}
                    onChange={(tabId) => onTabChange(tabId as ComputedSubstitutionTabType)}
                    data-testid="substitutions-tabs"
                />
                <Button variant="primary" onClick={handleCreate} data-testid="substitutions-create-btn" className="tw-my-2" disabled={!createPermission}>
                    Create
                </Button>
            </div>
            <div className="tw-w-full tw-border-b tw-border-edge"></div>

            {activeTab === "weightage" ? <ComputedSubstitutionComponent isSidePanel={isSidePanel} /> : <IterationTable />}
        </>
    )
}
